import './HomePage.css';

export default function HomePage() {
  return(
    <>
      <h1 className="HomeHeadline">Welcome to Donut Depot</h1>
      <div className="Backdrop">
        <img src="https://i.ibb.co/58BMdks/Screen-Shot-2022-12-22-at-6-34-52-AM-removebg-preview.png" alt="logo" className="HomeImage"/>
      </div>
    </>
  );
}